module.exports = __webpack_public_path__ + "img/Mantle.66088c1b.png";